"use client";

import { createContext, useContext, type ReactNode } from "react";
import { usePathname } from "next/navigation";

import { withSitePrefix } from "@/lib/site/site-routing";

const SitePrefixContext = createContext("");

export function SitePrefixProvider({ prefix, children }: { prefix: string; children: ReactNode }) {
  return <SitePrefixContext.Provider value={prefix}>{children}</SitePrefixContext.Provider>;
}

export function useSitePrefix(): string {
  return useContext(SitePrefixContext);
}

export function useSiteHref(): (href: string) => string {
  const prefix = useSitePrefix();

  return (href: string) => withSitePrefix(href, prefix);
}

export function useSitePathname(): string {
  const pathname = usePathname() ?? "/";
  const prefix = useSitePrefix();

  if (!prefix || pathname === prefix || pathname.startsWith(`${prefix}/`)) {
    return pathname;
  }

  return `${prefix}${pathname}`;
}
